<template>
  <div class="page-dialog-with-action" v-if="actionDialogShow" ref="MsgWithActionDialogPage">
    <div class="content-dialog-with-action" ref="MsgWithActionDialogContent">
      <div class="concrete-content">
        <div class="title" v-show="checkNull(title)" v-text="title"></div>
        <div class="content" v-show="checkNull(msg)" v-text="msg"></div>
      </div>
      <div :class="'btm-action-panel '+(type==1?'single':'double')" v-if="[1,2].indexOf(type)!=-1">
        <div class="action" v-for="(item,index) in btns" v-text="item" @click="doAction(index)"></div>
      </div>
    </div>
  </div>
</template>

<script>
import {isnull} from "../../utils/tools";
import FBQ from "../../utils/fbqutils";
import StatisticsHelper from "../../utils/StatisticsUtils";

export default {
  name: 'msg-dialog',
  props: {
    actionDialogShow: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    msg:{
      type: String,
      default: ''
    },
    type: {
      type: Number,
      default: 1
    },
    btns: {
      type: Array,
      default: []
    },
    hideFromOutSide: {
      type: Boolean,
      default: true,
    },
    extra: ''
  },
  methods: {
    checkNull(src){
      return !isnull(src)
    },
    doAction(index) {
      StatisticsHelper.user_action()
      this.$emit('commonaction' + (index + 1), this.extra)
    },
    hideMsgWithSelf() {
      StatisticsHelper.user_action()
      this.$emit('hideCommonActionDialog')
    },
    bodyMsgWithActionDialog(e) {
      let self = this
      if (this.$refs.MsgWithActionDialogContent && !this.$refs.MsgWithActionDialogContent.contains(e.target)) {
        self.hideMsgWithSelf()
      }
    },
  },
  watch: {
    msgDialogShow(n, o) {
      if (n) {
        let target = this
        setTimeout(function () {
          if (target.hideFromOutSide) {
            target.$refs.MsgWithActionDialogPage.addEventListener('click', target.bodyMsgWithActionDialog)
          }
        }, 100)
      } else {
        if (this.hideFromOutSide) {
          this.$refs.MsgWithActionDialogPage.removeEventListener('click', this.bodyMsgWithActionDialog)
        }
      }
    }
  },
}
</script>

<style scoped lang="less">
@import "~styles/index.less";
@import "~styles/variable.less";

.page-dialog-with-action {
  position: fixed;
  z-index: 1001;
  margin: 0;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, .3);

  .content-dialog-with-action {
    .w(540);
    top: 50%;
    position: fixed;
    transform: translate(calc(50vw - 50%), -50%);

    .concrete-content {
      .w(540);
      .fs(30);
      .lh(40);
      .minh(242);
      background: #fff;
      .pt(60);
      .b-radius(24, 24, 0, 0);

      .title {
        text-align: center;
        .w(500);
        .ml(20);
        .fs(36);
        font-family: Gilroy-Bold;
        color: #333333;
        .lh(43);
      }
      .content{
        text-align: center;
        .w(500);
        .ml(20);
        .fs(28);
        font-family: Gilroy-Bold;
        color: #9AA3AF;
        .lh(33);
        .mt(29);
      }
    }
    .btm-action-panel{
      margin-top: -1px;
    }

    .btm-action-panel.single {
      //background: #42b983;
      background: #FF0E74;
      .h(84);
      color: white;
      .b-radius(0, 0, 24, 24);

      .action {
        .fs(32);
        .lh(84);
        cursor: pointer;
        font-family: Gilroy-Bold;
      }

    }

    .btm-action-panel.double {
      .h(84);
      color: white;
      font-size: 0;

      .action {
        .fs(32);
        .lh(84);
        width: 50%;
        display: inline-block;
        cursor: pointer;
        font-family: Gilroy-Bold;

      }

      .action:first-child {
        color: #9AA3AF;
        .b-radius(0, 0, 0, 24);
        background: #E6E7EA;
      }

      .action:last-child {
        .b-radius(0, 0, 24, 0);
        background: #FF0E74;
      }

    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/widget/commondialog.vue